import React from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const FooterContainer = styled.div`
  background-color: #fff;
  padding-top: 32px;
  padding-bottom: 32px;
`;

const AppFooter: React.FC = () => {

  const { t } = useTranslation();
  return (
    <FooterContainer>
      <Row justify="center" align="middle">
        <Col>
          <span style={{ color: 'black' }}>
            {t('RESOURCES.EVENT.LABELS.FOOTER_COPYRIGHTS', { year: new Date().getFullYear() })}
          </span>
        </Col>

      </Row>
    </FooterContainer>
  );
};


export default AppFooter;